<script>
import AccordionPlusIcon from './AccordionPlusIcon'

export default {
  name: 'AccordionTitle',
  components: {
    AccordionPlusIcon
  },
  props: {
    scale: {
      type: Number,
      default: 1
    },
    color: {
      type: String,
      default: 'black'
    },
    title: {
      type: String,
      required: true
    }
  },
  computed: {
    styles () {
      return {
        container: {
          '--scale': this.scale,
          '--color': this.color
        },
        title: {
          '--color': this.color
        }
      }
    }
  },
  methods: {
    handleClick () {
      this.$refs.icon.animate()
    }
  }
}
</script>

<template>
  <div
    class="accordion-title-container"
    :style="styles.container"
    @click="handleClick"
  >
    <AccordionPlusIcon
      ref="icon"
      :scale="scale"
      :color="color"
      class="icon"
    />
    <div
      class="title"
      :style="styles.title"
      v-html="title"
    />
  </div>
</template>

<style lang="scss" scoped>
.accordion-title-container {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: calc(15px * var(--scale))
           calc(60px * var(--scale))
           calc(15px * var(--scale))
           calc(30px * var(--scale));
  position: relative;
  .title {
    color: var(--color);
    margin-left: calc(30px * var(--scale));
    font: bold calc(18px * var(--scale))/calc(32px * var(--scale)) 'Open Sans';
  }
  &:hover {
    &::before {
      content: '';
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      background-color: var(--color);
      opacity: 0.1;
      z-index: -1;
      position: absolute;
    }
  }
}
</style>
